import React, { useEffect } from 'react';
import { trackAppDownloadBannerClicked, trackAppDownloadBannerLoad } from '../../../utils/omnitureUtils';
import '../../../styles/AppDownload.css';

interface AppDownloadProps {
  data: {
    text: string;
    subtext: string;
    ctaDefaultText: string;
    ctaDeeplink: string;
  };
  omnitureData: {
    shownEvent: string;
    clickEvent: string;
  };
}

function AppDownload({ data, omnitureData }: AppDownloadProps) {
  const handleOmniture = async () => {
    trackAppDownloadBannerLoad(omnitureData.shownEvent);
  };

  useEffect(() => {
    handleOmniture();
  }, []);

  const isButtonClicked = () => {
    if (data?.ctaDeeplink) {
      window.open(data?.ctaDeeplink, '_blank');
    }
    trackAppDownloadBannerClicked(omnitureData.clickEvent);
  };

  return (
    <div className="appDownloadContainer">
      <div className="makeFlex hrtlCenter appendBottom12">
        <span className="appDownloadSprite appdownloadIcon appendRight15"></span>
        <div>
          <p className="font14 lineHeight20 latoBold blackText">{data?.text}</p>
          <p className="font12 lineHeight16 darkGreyText">{data?.subtext}</p>
        </div>
      </div>
      <button type="submit" className="appDownloadButton" onClick={isButtonClicked}>
        {data?.ctaDefaultText}
      </button>
    </div>
  );
}

export default AppDownload;
